<template>
  <ConfigurationLayout>
    <template #headerBar>
      <HeaderBar
        v-if="route.name === 'configuration'"
        class="hide-for-medium"
        :modifiers="['dark', 'padding-y-medium']"
      >
        <router-link
          :aria-label="$t('general.back')"
          class="header-bar__title header-bar__title--full-width typo-nav-item"
          :to="{ name: 'operation' }"
        >
          <UseSvg
            class="icon"
            name="arrow_left"
          />
          <div class="typo-small-title text-center">
            {{ $t('nav.configuration') }}
          </div>
        </router-link>
      </HeaderBar>

      <HeaderBar
        class="show-for-medium"
        :modifiers="['transparent', 'more-padding', 'more-height']"
      >
        <router-link
          class="button button--margin-right"
          :to="{ name: 'operation' }"
        >
          <LeftArrow class="icon" />
        </router-link>
        <p class="header-nav__title typo-ignore">
          {{ $t('nav.configuration') }}
        </p>
      </HeaderBar>
    </template>
    <template #panelContent>
      <component :is="currentComponentName" />
    </template>
  </ConfigurationLayout>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

// Components
import HeaderBar from '@/components/generic/header_bar.vue';
import ConfigurationLayout from '@/components/plants/configuration/configuration_layout.vue';
import ConfigurationPlant from '@/components/plants/configuration/configuration_plant.vue';
import ConfigurationHme from '@/components/plants/configuration/configuration_hme.vue';

// Icons
import UseSvg from '@/components/generic/use_svg.vue';
import LeftArrow from '@/images/arrow-left.svg';

defineProps({
  organisationId: { type: String, required: true },
  operationId: { type: String, required: true },
});

const route = useRoute();

/**
 * Display correct panel component
 */
const currentComponentName = computed(() => {
  const condition = ['configuration/plants', 'configuration/heavy_mobile_equipment'];
  const currentRoute = condition.find((url) => route.path.includes(url));

  switch (currentRoute) {
    case condition[1]:
      return ConfigurationHme;

    default:
      return ConfigurationPlant;
  }
});
</script>
